import React from 'react';
export const Link = ({ to, children, ...rest }) => {
    return <a href={to} {...rest}>{children}</a>;
};
